
import { defineComponent, computed, ComputedRef, SetupContext } from 'vue';
import colors from 'tailwindcss/colors';
import { useStore } from '@/store';
import UseIcon from '@/components/UseIcon/UseIcon.vue';
import WizardFeedback from '@/components/Wizard/WizardFeedback.vue';
import useNavigation, { Navigation } from '@/composables/Navigation';

interface SetupReturn {
    emit: SetupContext['emit'];
    back: Navigation['back'];
    label: ComputedRef<string>;
    colors: any;
    canGoBack: ComputedRef<boolean>;
    canShowAdditionalControlAndInfo: ComputedRef<boolean>;
}

export default defineComponent({
    components: {
        UseIcon,
        WizardFeedback,
    },
    emits: ['close-box'],
    setup(_, { emit }: SetupContext): SetupReturn {
        const store = useStore();
        const { back } = useNavigation();
        const type = computed(() => {
            return store.getters.feedbackType;
        });
        const component = computed(() => {
            return store.getters.currentComponent;
        });

        const label = computed<string>(() => {
            if (type.value === 'ISSUE') {
                return 'Reporte um problema';
            }

            if (type.value === 'IDEA') {
                return 'Conte a sua ideia';
            }

            if (type.value === 'OTHER') {
                return 'Abra a sua mente';
            }

            return 'O que você tem em mente?';
        });

        const canGoBack = computed<boolean>(() => {
            return component.value === 'SelectFeedbackType';
        });
        const canShowAdditionalControlAndInfo = computed<boolean>(() => {
            return component.value !== 'SuccessSave' && component.value !== 'ErrorSave';
        });

        return {
            emit,
            back,
            label,
            colors,
            canGoBack,
            canShowAdditionalControlAndInfo,
        };
    },
});
